import * as types from './passwords.types';

export const passwordsPageSelectors: types.IPasswordPageSelectors = {
  selectPasswordIds: (state) => state.page.passwords.passwordIds,
  selectFiltederPasswordIds: (state) => state.page.passwords.filteredPasswordIds,
  selectFilterParams: (state) => state.page.passwords.filterParams,
};
